import { FC, useState } from 'react';
import {
  Button,
  ButtonSize,
  ButtonStyles,
  Modal,
  Theme,
  useTranslation,
  ButtonWidth,
  TextAlign,
  ButtonAlignment,
} from '@nextgen-web-framework/all';
import styles from './GcoConfirmationModal.module.scss';
import { GcoConfirmationModalProps } from './types/propsTypes';

const GcoConfirmationModal: FC<GcoConfirmationModalProps> = ({ onCancelClick, onContinueClick }) => {
  const [onClose, setOnClose] = useState(true);

  const onDiscardButtonClick = (e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
    if (onCancelClick) {
      onCancelClick();
    }
    setOnClose(false);
  };
  const t = useTranslation();

  const onGoButtonClick = (e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
    if (onContinueClick) {
      onContinueClick();
    }
    setOnClose(false);
  };

  return (
    <div className={styles['have-an-modal-container']} data-testid="have-an-modal-container-id">
      {onClose && (
        <Modal
          // headline={t('subscription.SubscriptionOrderSummary.gcoModal.headingText')}
          headline={t('subscription.SubscriptionOrderSummary.cartModeSwitch.headingText')}
          primaryButtonLabel={''}
          // primaryButtonLabel={t('subscription.SubscriptionOrderSummary.gcoModal.continue.buttonText')}
          // secondaryButtonLabel={t('subscription.SubscriptionOrderSummary.gcoModal.cancel.buttonText')}
          // onPrimaryButtonClick={onGoButtonClick}
          // onSecondaryButtonClick={onDiscardButtonClick}
          buttonAlignment={ButtonAlignment.VERTICAL}
          closeIcon={false}
          // textAlign={TextAlign.LEFT}
          textAlign={TextAlign.CENTER}
          textLinkProps={{ text: '' }}
          primaryButton={
            <Button
              theme={Theme.BLACK}
              buttonStyle={ButtonStyles.SOLID}
              size={ButtonSize.MEDIUM}
              title={t('subscription.SubscriptionOrderSummary.cartModeSwitch.continue.buttonText')}
              buttonWidth={ButtonWidth.FULL_WIDTH}
              data-testid="gco-continue-testid"
              onClick={onGoButtonClick}
            />
          }
          secondaryButton={
            <Button
              title={t('subscription.SubscriptionOrderSummary.cartModeSwitch.cancel.buttonText')}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              size={ButtonSize.MEDIUM}
              buttonWidth={ButtonWidth.FULL_WIDTH}
              data-testid="gco-cancel-testid"
              onClick={onDiscardButtonClick}
            />
          }
          footerClassname={styles['gco-confirmation-modal-footer']}
          useReactPortal={true}
          portalContainerId="react-portal-modal"
        >
          <span className={styles['have-an-modal-description']}>
            {/* {t('subscription.SubscriptionOrderSummary.gcoModal.descriptionText')} */}
            {t('subscription.SubscriptionOrderSummary.cartModeSwitch.descriptionText')}
          </span>
        </Modal>
      )}
    </div>
  );
};

export default GcoConfirmationModal;
